// extracted by mini-css-extract-plugin
export default {"warning":"XoooPt5lkarZbS3i3c9o"};